<template>
  <dropdown v-model="selected" label="Vztah k-eshopu" :errors="errors" :data="data"></dropdown>
</template>

<script>
import Dropdown from "../Atomic/Dropdown.vue";

const data = [
  {
    id: "majitel",
    name: "Majitel",
  },
  {
    id: "zamestnanec",
    name: "Zaměstnanec",
  },
];

export default {
  components: {
    Dropdown,
  },

  emits: ["update:modelValue"],

  props: {
    modelValue: Object,
    
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      data: data,
      defaultOption: {
        id: "non-selected",
        name: "Jaký je váš vztah k e-shopu"
      }
    };
  },

  computed: {
    selected: {
      get() {
        return this.modelValue || this.defaultOption;
      },

      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>

<style>
</style>